import React, { createContext, useContext, useState } from 'react';
import AuthStates from './AuthorizationState';
import AuthorizationBehaviour from './AuthorizationBehaviour';
import AuthorizationView from './AuthorizationView';


const AuthStateContext = createContext({ authState: AuthStates.NotLoaded,
    setAuthState: () => {}, });

export const useAuthStateContext = () => useContext(AuthStateContext);

const Authorization = ({ children }) => {
    const [authState, setAuthState] = useState(AuthStates.NotLoaded);
    return (
        <AuthStateContext.Provider value={{ authState, setAuthState }}>
            <AuthorizationBehaviour>
                <AuthorizationView>
                    {children}
                </AuthorizationView>
            </AuthorizationBehaviour>
        </AuthStateContext.Provider>
    );
};

export default Authorization;